import { ABP } from '@abp/ng.core';
import { Layout } from '../models/layout';

export class SetMenuStatus {
  static readonly type = '[Layout] Set Menu Status';
  constructor(public payload: Layout.MenuStatus) { }
}

export class SetMenuPlacement {
  static readonly type = '[Layout] Set Menu Placement';
  constructor(public payload: Layout.MenuPlacement) { }
}

export class SetLayoutBoxed {
  static readonly type = '[Layout] Set Layout Boxed';
  constructor(public payload: boolean) { }
}

export class SetStyle {
  static readonly type = '[Layout] Set Style';
  constructor(public payload: number) { }
}

export class GetThemeSettings {
  static readonly type = '[Layout] Get Theme Settings';
}

export class UpdateThemeSettings {
  static readonly type = '[Layout] Update Theme Settings';
  constructor(public payload: Layout.ThemeSettings) { }
}

export class SetSelectedSettingTab {
  static readonly type = '[M.SettingManagement] Set Selected Tab';
  constructor(public payload: ABP.Tab) { }
}